import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import * as Chart from 'chart.js';
import { MatDialog } from '@angular/material/dialog';
import { ExportDialogComponent } from '../export-dialog/export-dialog.component';
import { ChartService } from '../../services/chart.service';
declare var createPieChart: any;
import html2canvas from 'html2canvas';

import jsPDF from 'jspdf';


@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit,AfterViewInit {
  @ViewChild('myChart') chartRef: ElementRef;
  @ViewChild('barChartCanvas') chartRefH: ElementRef;
  @ViewChild('doughnutChart') doughnutChart: ElementRef;
  chartInstance: Chart;
  
  @ViewChild('horizotalChartCanvas') horizontalChart: ElementRef;
  private horizontalChartH: Chart;

  @ViewChild('horizotalSecondChartCanvas') horizontalSecondChart: ElementRef;
  private horizontalSecondChartH: Chart;
  private chartH1: Chart;

  private chartH: Chart;

   charts: Chart;

  mapData:any;
  stateData:any;
  districtData:any;
  @ViewChild('content') content: ElementRef;
  cardList: any = [];
  facilityList:any=[];
  showFilter: boolean = false;
  startDate: any = "";
  endDate: any = "";
  startDateFormated: any = "";
  endDateFormated: any = "";
  csvDownloadAPI = 'user/csv';
  csvFileName = 'admin_dashboard';
  @Output() showSideBar = new EventEmitter();
  showSideMenu: boolean = false;
  selectedRow: any = null;
  facilitiesBedSizeData:any=true;
  monthlyData:any=true;
  qiProvidersData:any=true;
  originalFacilityList:any=[];
  originalStateList:any=[];
  columnList = [
    {
      name: 'QI Providers',
      key:'cse_name',
    },
    {
      name: 'No. of Facilities',
      key:'userCount',
    }
  ]

  columnList1 = [
    {
      name: 'State',
      key:'state_name',
    },
    {
      name: 'No. of Facilities',
      key:'count',
    }
  ]

  cse_name = '';
  state_name = '';
  year_id!:string;

  tableData:any;
  cseParams: string = ''
  params='';

  tableData1:any;
  
  tableData2 = []
  facilitiesRegisteredbyMonth:any;
  grandTotal:any;
  grandTotal1:any;
  sortedTableData: any[] = [];
  sortedTableDataStateWise: any[] = [];
  currentSortColumn: string = '';
  isAscending: boolean = true;
  stateData1: any;
  highlightTab: any;
  stateOptionList: any;
  cseName:string='';
  years:any=[];
  constructor(private adminService: AdminService,public dialog: MatDialog,private chartService:ChartService) {
   
    this.getDistrictData('')
    this.adminService.stateRegisteredFacilitiesListing('',sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log("responseresponse",response);
      this.stateOptionList = response.data;
      this.originalStateList=this.stateOptionList
    })

    this.adminService.getMapListing('', sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log(response['data'],'data');
      this.facilityList = response.data; 
      this.originalFacilityList=this.facilityList
    })

   }

  ngOnInit(): void {
   this.yearList()
    this.onLoad();
    this.getCSEMappedListDeatils();
    this.horizontalBarChart();
    this.horizontalSecondBarChart();
    this.stateRegisteredFacilitiesListingDeatils('');
  }
  ngAfterViewInit(): void {
    this.createDoughnutChart();
    this.createDoughnutChartAnother();
    this.registrationSourcePieChart()
    const currentYear = new Date().getFullYear();
    let filter = `year=${currentYear-1}-${currentYear}`;
    this.year_id = `${currentYear-1}-${currentYear}`;
    this.createLineChart(filter)
  }
  yearList(){
    const currentYear = new Date().getFullYear(); // Get the current year
  // Initialize an empty array to store the year ranges
  this.years = [];

 /* The above code is creating a loop that starts from the year 2020 and continues until the current
 year. Inside the loop, it creates a string representing a range of years (e.g. "2020-2021") and
 pushes an object with an "id" and "value" property representing the year range into an array called
 "years". */
  for (let year = 2020; year < currentYear; year++) {
    const yearRange = `${year}-${year + 1}`;
    this.years.push({ id: yearRange, value: yearRange });
  }

  // Add the current year range
  const currentYearRange = `${currentYear}-${currentYear + 1}`;
  this.years.push({ id: currentYearRange, value: currentYearRange });
  }

  onLoad(params?) {
    let filter=''
    if(params){
      filter=params
    }
     // Call adminDashboardOperation and subscribe to the response
    this.adminService.adminDashboardOperation(filter).subscribe((response: any) => {
 // Update cardList based on the response data
      this.cardList = [
        {
          header: "Facilities in Pipeline",
          data: 215,
          gradientClass: 'bg-initiated',
          fontColor:'iconColor',
          tooltipText:'Represents facilities in Pipeline.',
        },
        {
          header: "Registration Initiated",
          data: response?.data?.regInitiated,
          gradientClass: 'bg-initiated',
          fontColor:'iconColor',
          tooltipText:'Represents facilities in registration. Includes those in progress and completed registrations. ',
        },
        {
          header: "Registration Completed",
          data: response?.data?.regCompleted,
          paymentCompleted: response?.data?.paymentPercentage,
          fontColor:'iconColor',
          gradientClass: 'bg-registration-completed',
          tooltipText:'Represents the count of facilities with completed profiles from Manyata registrations.',
        },
        {
          header: "Payment Completed",
          data: response?.data?.paymentCompleted,
          gradientClass: 'bg-payment-completed',
          tooltipText:'Represents the count of facilities that have completed their profiles and successfully made payments.',
        }
        ,
        {
          header: "Facilties Registered Under Momentum Scheme",
          data: 222,
          gradientClass: 'bg-payment-completed',
          tooltipText:'Represents facilties registered under momentum scheme',
        }
        ,
        {
          header: "Facilities Undergoing QI",
          data: response?.data?.facilitiesUndergoingQi,
          gradientClass: 'bg-facilities-undergoing',
          tooltipText:'',
        },
        {
          header: "Facilities Ready for QA",
          data:response?.data?.readyForQA,
          gradientClass: 'bg-ready',
          tooltipText:'',
        },
        {
          header: "Facilities Certified",
          data:response?.data?.certified,
          gradientClass: 'bg-certified',
          tooltipText:'',
        }
      ]
    },
      (error) => {
        Swal.fire('Error', error.error.message, 'error');
      })
  }

  applyClick() {
    this.facilitiesBedSizeData = true;
    this.qiProvidersData = true
      // Format start and end dates
    if (this.startDate !== "" && this.endDate !== "") {
      this.startDateFormated = moment(this.startDate).format("YYYY-MM-DD ");
      this.endDateFormated = moment(this.endDate).format("YYYY-MM-DD");
    }
    const filter = `cse_name=${this.cse_name}&state=${this.state_name}`
    console.log(this.startDateFormated, this.endDateFormated, filter, 'filter');
 // Check if necessary fields are not empty or undefined
    if (this.startDate !== "" && (this.endDate !== "") || (this.cse_name != "" && this.cse_name != undefined) || (this.state_name != "" && this.state_name != undefined)) {
      let filter = '';
      if (this.startDateFormated) {
        filter += `from=${this.startDateFormated}`;
      }
      if (this.endDateFormated) {
        if (filter) {
          filter += '&';
        }
        filter += `to=${this.endDateFormated}`;
      }
      if (this.cse_name) {
        if (filter) {
          filter += '&';
        }
        filter += `name=${this.cse_name}`;
      }
      if (this.state_name) {
        if (filter) {
          filter += '&';
        }
        filter += `state_name=${this.state_name}`;
      }
      if (filter) {
        this.getCSEMappedListDeatils(filter)
        this.createDoughnutChart(filter)
        this.stateRegisteredFacilitiesListingDeatils(filter)
        this.onLoad(filter);
      }
    }

  }
   // Call functions with the filter
  conditionInputValue(data: any) {
    const filteredQiProviders = this.facilityList.find((obj: any) => obj.cseId === data);
    this.cseName= filteredQiProviders.cse_name
console.log('data',this.cseName)
  }
/**
 * Resets the component state and triggers data retrieval and chart creation.
 */
  reset() {
     // Resetting flags and date-related properties
    this.facilitiesBedSizeData = true
    this.qiProvidersData=true
    this.startDate = "";
    this.endDate = "";
    this.startDateFormated = "";
    this.endDateFormated = "";
    this.state_name="";
    this.cse_name="";
    this.cseName="";
     // Constructing filter string
    let filter =`from=${this.startDateFormated}&to=${this.endDateFormated}&name=${this.cse_name}&state_name=${this.state_name}`
     // Triggering data retrieval and chart creation functions
    this.stateRegisteredFacilitiesListingDeatils(filter)
    this.getCSEMappedListDeatils(filter)
    this.createDoughnutChart(filter)
    this.onLoad(filter);
   
  }

  showSideBarMenu() {
    this.showSideMenu = !this.showSideMenu;
    this.showSideBar.emit(this.showSideMenu)
  }
  /**
   * The function `getCSEMappedListDeatils` retrieves data from an API, processes it, and displays it
   * in a bar chart.
   * @param [params] - The `params` parameter is an optional parameter that can be passed to the
   * `getCSEMappedListDeatils` function. It is used to filter the data that is fetched from the
   * `adminService.getMapListing` API. If `params` is provided, it will be used as the filter
   */
  getCSEMappedListDeatils(params?) {
    this.tableData = [];
    let filter='';
    if(params){
      filter=params
    }
    console.log(this.cseParams);
    this.adminService.getMapListing(filter, sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log(response['data'],'data');
      this.tableData = response.data; 
      const latestData=response.data?.slice(0, 5);
      this.grandTotal = this.tableData.reduce(
        (total, current) => total + parseInt(current.userCount || '0'),
        0
      )
       // Check if response data is empty
      if(!response.data.length){
        this.qiProvidersData = false
      }
   // Sort table and destroy chart instances
      this.sortTable('cse_name','cse');
      if (this.chartH) this.chartH.destroy();
 // Set up chart data
      const ctx = this.chartRefH.nativeElement.getContext('2d');
      const dataLabels =  latestData.map(item => item.cse_name);
      const dataValues =  latestData.map(item => item.userCount);
  
      const maxDataValue = Math.max(...dataValues);
  
      Chart.plugins.register({
        afterDatasetsDraw: function (chart) {
          if (chart.config.type === 'bar') { // Only apply this code for line charts
            const ctx = chart.ctx;
            const datasets = chart.config.data.datasets;
  
            datasets.forEach(function (dataset, datasetIndex) {
              const meta = chart.getDatasetMeta(datasetIndex);
              if (!meta.hidden) {
                meta.data.forEach(function (element, index) {
                  const data = dataset.data[index];
                  const x = element._model.x;
                  const y = element._model.y;
                  ctx.fillStyle = 'rgba(255, 255, 255, 255)'; // Change the color as needed
                  ctx.font = '12px Arial'; // Label font style
                  ctx.textAlign = 'center';
  
                  // Adjust the vertical position to display the value at the top of the bar
                  ctx.fillText(data +'', x, y + 15);
                });
              }
            });
          }
        },
      });
   // Create bar chart
      this.chartH = new Chart(ctx, {
        type: 'bar', // Use 'bar' for vertical bar chart
        data: {
          labels: dataLabels,
          datasets: [{
           // label: 'QI Providers',
            data: dataValues,
            backgroundColor: 'rgb(237,21,86)',
            borderColor: 'rgb(237,21,86)',
            borderWidth: 1,
            barPercentage: 0.5,
            barThickness: 35
          }]
        },
        options: {
          responsive: true, // Make the chart responsive
          maintainAspectRatio: false, // Do not maintain the aspect ratio
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
               
                callback: function (value) {
                  // Customize the label to break into two lines
                  const words = value.split(' ');
                  return [ words.slice(0,3).join(' '), words.slice(3).join(' ')];
                },
                
              },
              gridLines: {
                display: false, // Hide x-axis grid lines
              },
              scaleLabel: {
                display: true,
                labelString: 'QI Providers',
              },
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
              
                autoSkip: false,
              },
              scaleLabel: {
                display: true,
                labelString: 'Number of Facilities',
              },
              // gridLines: {
              //   display: false, // Hide x-axis grid lines
              // }
            }]
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                //return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
                return 'Number of Facilities' + ': ' + tooltipItem.yLabel;
              }
            }
          },
          legend: {
            display: false, // Display the legend
            //position: 'bottom', // Set the legend position to 'bottom'
          },
          plugins: {
            datalabels: {
              color: 'white', // Set the color of the data labels
              display: true,  // Enable data label display
              font: {
                weight: 'bold'  // Make the data labels bold
              }
            },
          },
        }
      });


  
     // this.facilityList=this.tableData
      
    })
  
  }
  /**
 * Retrieves details for state-registered facilities and updates the component's table data.
 * @param params Optional parameters for filtering facilities.
 */
  stateRegisteredFacilitiesListingDeatils(params?) {
    this.tableData1 = [];
    let filter=''
    if(params){
      filter=params
    }
    // Call the adminService to fetch state-registered facilities listing
    this.adminService.stateRegisteredFacilitiesListing(filter,sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log("responseresponse",response);
      this.tableData1 = response.data;
      this.stateData=this.tableData1
      this.sortTable('state_name','state');
    })
  }
 /**
 * Fetches registered facilities listing details for a district.
 * @param params - The parameters for the request, typically a district name.
 */
  districtRegisteredFacilitiesListingDeatils(params) {
     // Make a request to the admin service to get district registered facilities listing
  // using the provided parameters and the authentication token from sessionStorage.
    this.adminService.districtRegisteredFacilitiesListing('name='+params,sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log(response['data']);
      this.tableData2 = response.data;
      this.districtData=this.tableData2
    })
  }
  
  createLineChart(params?) {
    let filter=''
    if(params){
      filter=params
    }
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  
    this.adminService.facilitiesRegisteredbyMonthListing(filter,sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log(response['data']);
      const data = response['data'];
      if(!data.length){
        this.monthlyData=false
      }
  
      // Extract labels and data from the JSON data
      const labels = data?.map(item => item.month);
      const datasetData = data?.map(item => parseInt(item.registereduser));
  
      const ctx = document.getElementById('lineChart');
  
      Chart.plugins.register({
        afterDatasetsDraw: function (chart) {
          if (chart.config.type === 'line') { // Only apply this code for line charts
            const ctx = chart.ctx;
            const datasets = chart.config.data.datasets;
  
            datasets.forEach(function (dataset, datasetIndex) {
              const meta = chart.getDatasetMeta(datasetIndex);
              if (!meta.hidden) {
                meta.data.forEach(function (element, index) {
                  const data = dataset.data[index];
                  const x = element._model.x;
                  const y = element._model.y;
                  ctx.fillStyle = 'rgba(241, 0, 150, 1)'; // Change the color as needed
                  ctx.font = '12px Arial'; // Label font style
                  ctx.textAlign = 'center';
                  // Adjust the vertical position to display the value at the top of the bar
                  ctx.fillText(data, x+16, y-2);
                });
              }
            });
          }
        },
      });
      if(this.chartH1){
        this.chartH1.destroy();
      }
      this.chartH1 = new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            {
             // label: 'Months',
              borderColor: 'rgb(237,21,86)',
              borderWidth: 2,
              pointBackgroundColor: 'rgb(237,21,86)',
              pointRadius: 5,
              tension: 0,
              backgroundColor: 'transparent', // Set the background color to transparent
              data: datasetData,
            },
          ],
        },
        options: {
          responsive: true, // Make the chart responsive
          maintainAspectRatio: false, // Do not maintain the aspect ratio
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                max: 100, // Set the maximum value for the Y-axis
              },
              scaleLabel: {
                display: true,
                labelString: 'Months',
              },
              // gridLines: {
              //   display: false, // Hide x-axis grid lines
              // }
            }],
            yAxes: [{
              ticks: {
                autoSkip: false, // Prevent auto-skipping of labels
              },
              gridLines: {
                display: false, // Hide x-axis grid lines
              },
              scaleLabel: {
                display: true,
                labelString: 'Number of Facilities',
              },
            }],
          },
          plugins: {
            datalabels: {
              color: 'white', // Set the color of the data labels
              display: true,  // Enable data label display
            },
          },
          legend: {
            display: false, // Display the legend
            //position: 'bottom', // Set the legend position to 'bottom'
          },
          layout: {
            padding: {
              top:21
            }
          }
        },
      });
    });
  }
  clear=true
  /**
 * Creates a doughnut chart using data from the admin service.
 * @param params Optional parameter to filter the data.
 */
createDoughnutChart(params?) {
 this.clear=false
  let filter=''
  if(params){
    this.clear=true
    filter=params
  }
  // Destroy existing chart instance if it exists
  if (this.chartInstance) {
    this.chartInstance.destroy();
  }
   // Fetch data from admin service based on filter and token
  this.adminService.facilitiesBedSizeListing(filter,sessionStorage.getItem("token")).subscribe((response: any) => {
    console.log(response['data']);
    const data = response['data'];
    if(!data.length){
      this.facilitiesBedSizeData = false
    }
    const labels = [];
    const datasetData = [];
    const percentages = [];
    const backgroundColors = [
      'rgb(255,165,0)',
      'rgb(237,21,86)',
      'rgb(80,55,148)',
       // Add more colors as needed
    ];
     // Transform data to match chart input format
    const transformedOutput = Object.keys(data[0]).map(key => ({
      label: data[0][key].label,
      value: data[0][key].count,
      percent:data[0][key].percent
    }));
    let bar = {graph_data:{data:transformedOutput}, _id:'pie'}
    console.log('bar',bar)
    const targetElement = "#mjm"; // Replace with your target element selector
    const label = "label"; // Replace with the name of the label property in your data
    
    // Call the createPieChart function with your parameters
    createPieChart(targetElement, label, transformedOutput,this.clear);
  });
}



createDoughnutChartAnother(params?) {
  this.clear=false
   let filter=''
   if(params){
     this.clear=true
     filter=params
   }
   // Destroy existing chart instance if it exists
   if (this.chartInstance) {
     this.chartInstance.destroy();
   }
    // Fetch data from admin service based on filter and token
   this.adminService.facilitiesBedSizeListing(filter,sessionStorage.getItem("token")).subscribe((response: any) => {
     console.log(response['data']);
     const data = [
      {
        "CME": {
          "count": 2,
          "label": "CME",
          "percent": "45.833"
        },
        "CSE": {
          "count": 52,
          "label": "CSE",
          "percent": "8.333"
        },
        "CSR": {
          "count": 1,
          "label": "CSR",
          "percent": "8.333"
        },
        "Events": {
          "count": 6,
          "label": "Events",
          "percent": "8.333"
        },
        "Self Outreach": {
          "count": 33,
          "label": "Self Outreach",
          "percent": "8.333"
        },
        "(blank)": {
          "count": 121,
          "label": "(blank)",
          "percent": "8.333"
        },
      }
    ]
     if(!data.length){
       this.facilitiesBedSizeData = false
     }
     const labels = [];
     const datasetData = [];
     const percentages = [];
     const backgroundColors = [
       'rgb(255,165,0)',
       'rgb(237,21,86)',
       'rgb(80,55,148)',
       'rgb(255, 165, 0)',
         'rgb(0, 128, 0)',
         'rgb(255,192,203)'
        // Add more colors as needed
     ];
      // Transform data to match chart input format
     const transformedOutput = Object.keys(data[0]).map(key => ({
       label: data[0][key].label,
       value: data[0][key].count,
      // percent:data[0][key].percent
     }));
     let bar = {graph_data:{data:transformedOutput}, _id:'pie'}
     console.log('bar',bar)
     const targetElement = "#mjm1"; // Replace with your target element selector
     const label = "label"; // Replace with the name of the label property in your data
     
     // Call the createPieChart function with your parameters
     createPieChart(targetElement, label, transformedOutput,this.clear);
   });
 }
/**
 * Downloads CSV file for facilities registered by QI Partner.
 * Uses the admin service to make an API call, and creates a CSV file from the response.
 */
  downloadCSV() {
     // Make API call to download CSV
    this.adminService.downloadCSV('master/cse/map_csv',this.params, sessionStorage.getItem("token")).subscribe((response: any) => {
      let file: string = 'facilities_registered_by_QI_Partner'+'.csv';
        // Create CSV file using the admin service
      this.adminService.createCsv(response,file);
    },
      (error) => {
        console.log(error);
        Swal.fire('Error', `${error.error.message}`, 'error')
      })
  }
  stateDataC(obj){
    this.selectedRow = obj;
    console.log(obj,'obj')
    console.log("response",this.stateData);
      
  }
/**
 * Downloads a chart as a PDF document.
 *
 * @param {string} templateRef - The reference ID of the chart template (e.g., 'facilities_in_pipline').
 * @param {string} title - The title to be displayed on the PDF document.
 */
  downloadChart(templateRef: string, title: string) {
     // Get the HTML element by ID
    var data: any = document.getElementById(templateRef); // Id of the table
    let imgWidth = 200; // Default imgWidth
  // Adjust image width for specific templateRef
    if (templateRef === 'facilities_in_pipline') {
      imgWidth = 180;
    }
  // Convert HTML element to canvas and generate data URL
    html2canvas(data).then((canvas: any) => {
      let imgHeight = canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png');
      let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
    
      // Calculate the horizontal position to center the image
      const xPos = (pdf.internal.pageSize.width - imgWidth) / 2;
    
      // Calculate the horizontal position to center the title
      const titleXPos = pdf.internal.pageSize.width / 2;
    
      // Add a title to the PDF based on the templateRef
      if (templateRef === 'facilities_in_pipline') {
        pdf.text(title, titleXPos, 10, { align: 'center' });
      } else if (templateRef === 'facilities_registered_by_month') {
        pdf.text(title, titleXPos, 10, { align: 'center' });
      } else {
        pdf.text(title, titleXPos, 10, { align: 'center' });
      }
    
      // Add the image
      pdf.addImage(contentDataURL, 'PNG', xPos, 40, imgWidth, imgHeight);
    
      pdf.save(templateRef + '.pdf'); // Generated PDF
    });
    
  }
  
  
  
  searchOnDropdown(value,controllername) {
    let inputText = value.toLowerCase();
    if (value !== '') {
      //data matches with search text and data should not be already selected
      if(controllername ==='cse_name'){
        this.originalFacilityList = this.facilityList.filter((item) =>
        item.cse_name?.toLowerCase().includes(inputText))
      }
      else if (controllername ==='state_name'){
        this.originalStateList = this.stateOptionList.filter((item) =>
        item.state_name?.toLowerCase().includes(inputText))
      }

    }
    else {
      if(controllername ==='cse_name'){
        this.originalFacilityList = this.facilityList;
      }
      else if (controllername ==='state_name'){
        this.originalStateList = this.stateOptionList;
      }
     
    }
  }
/**
 * The `sortTable` function is used to sort a table based on a specified column and heading.
 * @param {string} column - The column parameter is a string that represents the name of the column in
 * the table that needs to be sorted.
 * @param {string} heading - The "heading" parameter is a string that represents the heading of the
 * table column that needs to be sorted.
 */
  sortTable(column: string, heading: string) {
    if (this.currentSortColumn === column) {
      this.isAscending = !this.isAscending;
    } else {
      this.isAscending = true;
      this.currentSortColumn = column;
    }
    const multiplier = this.isAscending ? 1 : -1;
  
    const dataToSort = heading === 'cse' ? this.tableData : this.tableData1;
    const sortedDataKey = heading === 'cse' ? 'sortedTableData' : 'sortedTableDataStateWise';
    if(dataToSort.length > 1){
      this[sortedDataKey] = [...dataToSort].sort((a, b) => {
        const valueA = isNaN(a[column]) ? a[column] : parseFloat(a[column]);
        const valueB = isNaN(b[column]) ? b[column] : parseFloat(b[column]);
        if (valueA < valueB) return -1 * multiplier;
        if (valueA > valueB) return 1 * multiplier;
        return 0;
      });
    }else{
      this[sortedDataKey] = dataToSort;
    }
   
  }
/**
 * The function `downloadCsvState()` downloads a CSV file containing state-wise registered facilities.
 */
  downloadCsvState() {
    const csvContent = this.convertArrayToCSV(this.sortedTableDataStateWise);
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    // Create a link element and trigger the download
    const a = document.createElement('a');
    a.href = url;
    a.download = 'state_wise_registered_facilities.csv';
    a.click();
    // Clean up
    window.URL.revokeObjectURL(url);
  }
/**
 * The function `convertArrayToCSV` takes an array of data and converts it into a CSV string with
 * headers and rows.
 * @param {any[]} data - an array of objects, where each object represents a row of data. Each object
 * has two properties: state_name (string) and count (number).
 * @returns The function `convertArrayToCSV` returns a string that represents the data in CSV format.
 */
  convertArrayToCSV(data: any[]): string {
    const header = 'QI Providers,No. of Facilities'; // Change headers here
    const rows = data.map((row) =>
      [row.state_name, row.count].map((value) => `"${value}"`).join(',')
    );
    return `${header}\n${rows.join('\n')}`;
  }

/**
 * The function `getDistrictData` takes a stateId as input and performs some operations based on that
 * input.
 * @param {any} stateId - The stateId parameter is an object that contains the following properties:
 */
  getDistrictData(stateId: any) {
    this.highlightTab = this.sortedTableDataStateWise.find(ele => ele.state_name == stateId?.ST_NM);
    const obj = {
      state_name: stateId.ST_NM,
      count: stateId.count
    }
    console.log('xxxx', obj)
    this.districtRegisteredFacilitiesListingDeatils('')
    this.stateDataC(obj)
  }
/**
 * The function logs the selected year ID and creates a line chart based on the selected year.
 * @param {any} event - The event parameter is the event object that is triggered when the year
 * selection is changed. It contains information about the event, such as the target element and any
 * additional data associated with the event.
 */
  onYearSelectionChange(event: any) {
    console.log('event',event)
    console.log('Selected Year ID:', this.year_id);
    let filter = '';
    if (this.year_id) {
      filter += `year=${this.year_id}`;
    }
    this.monthlyData=true
    this.createLineChart(filter)
  }

  registrationSourcePieChart(params?) {
    this.clear=false
     let filter=''
     if(params){
       this.clear=true
       filter=params
     }
     // Destroy existing chart instance if it exists
     if (this.chartInstance) {
       this.chartInstance.destroy();
     }
      // Fetch data from admin service based on filter and token
     this.adminService.facilitiesBedSizeListing(filter,sessionStorage.getItem("token")).subscribe((response: any) => {
       console.log(response['data']);
      // const data = response['data'];
       const data = [
         {
           "CME": {
             "count": 1,
             "label": "CME",
             "percent": "45.833"
           },
           "Consultant": {
             "count": 120,
             "label": "Consultant",
             "percent": "45.833"
           },
           "CSE": {
             "count": 399,
             "label": "CSE",
             "percent": "8.333"
           },
           "Events": {
             "count": 12,
             "label": "Events",
             "percent": "8.333"
           },
           "QI Provider": {
             "count": 134,
             "label": "QI Provider",
             "percent": "8.333"
           },
           "Self Outreach": {
             "count": 86,
             "label": "Self Outreach",
             "percent": "8.333"
           }
         }
       ]
       if(!data.length){
         this.facilitiesBedSizeData = false
       }
       const labels = [];
       const datasetData = [];
       const percentages = [];
       const backgroundColors = [
         'rgb(255,165,0)',
         'rgb(237,21,86)',
         'rgb(80,55,148)',
         'rgb(255, 165, 0)',
         'rgb(0, 128, 0)',
         'rgb(255,192,203)'
          // Add more colors as needed
       ];
        // Transform data to match chart input format
       const transformedOutput = Object.keys(data[0]).map(key => ({
         label: data[0][key].label,
         value: data[0][key].count,
        // percent:data[0][key].percent
       }));
       let bar = {graph_data:{data:transformedOutput}, _id:'pie'}
       console.log('bar',bar)
       const targetElement = "#registrationsource"; // Replace with your target element selector
       const label = "label"; // Replace with the name of the label property in your data
       
       // Call the createPieChart function with your parameters
       createPieChart(targetElement, label, transformedOutput,this.clear);
     });
   }


  horizontalBarChart(params?) {
    this.tableData = [];
    let filter='';
    if(params){
      filter=params
    }
    console.log(this.cseParams);
    this.adminService.getMapListing(filter, sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log(response['data'],'data');
      this.tableData = response.data; 
      //const latestData=response.data?.slice(0, 5);
      const latestData=[
        {
          "name": "ARTIST",
          "value": 490
        },
        {
          "name": "Eva Multispeciality Clinic",
          "value": 40
        },
        {
          "name": "Gupte CSE",
          "value": 477
        },
        {
          "name": "KHIPS",
          "value": 283
        },
        {
          "name": "Krishna CSE",
          "value": 83
        },
        {
          "name": "NMOGS",
          "value": 548
        },
        {
          "name": "OMEGA",
          "value": 472
        },
        {
          "name": "Vyas CSE",
          "value": 141
        }
      ]
      
      this.grandTotal = this.tableData.reduce(
        (total, current) => total + parseInt(current.userCount || '0'),
        0
      )
       // Check if response data is empty
      if(!response.data.length){
        this.qiProvidersData = false
      }
   // Sort table and destroy chart instances
      this.sortTable('cse_name','cse');
      if (this.horizontalChartH) this.horizontalChartH.destroy();
 // Set up chart data
      const ctx = this.horizontalChart.nativeElement.getContext('2d');
      const dataLabels =  latestData.map(item => item.name);
      const dataValues =  latestData.map(item => item.value);
  
      const maxDataValue = Math.max(...dataValues);
  
      Chart.plugins.register({
        afterDatasetsDraw: function (chart) {
          if (chart.config.type === 'horizontalBar') { // Only apply this code for line charts
            const ctx = chart.ctx;
            const datasets = chart.config.data.datasets;
  
            datasets.forEach(function (dataset, datasetIndex) {
              const meta = chart.getDatasetMeta(datasetIndex);
              if (!meta.hidden) {
                meta.data.forEach(function (element, index) {
                  const data = dataset.data[index];
                  const x = element._model.x;
                  const y = element._model.y;
                  ctx.fillStyle = 'rgba(255, 255, 255, 255)'; // Change the color as needed
                  ctx.font = '12px Arial'; // Label font style
                  ctx.textAlign = 'center';
  
                  // Adjust the vertical position to display the value at the top of the bar
                  ctx.fillText(data +'', x-10, y );
                });
              }
            });
          }
        },
      });
   // Create bar chart
      this.horizontalChartH = new Chart(ctx, {
        type: 'horizontalBar', // Use 'bar' for vertical bar chart
        data: {
          labels: dataLabels,
          datasets: [{
           // label: 'QI Providers',
            data: dataValues,
            backgroundColor: 'rgb(237,21,86)',
            borderColor: 'rgb(237,21,86)',
            borderWidth: 1,
            barPercentage: 0.4,
            barThickness: 34
          }]
        },
        options: {
          responsive: true, // Make the chart responsive
          maintainAspectRatio: false, // Do not maintain the aspect ratio
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                
              },
              gridLines: {
                display: false, // Hide x-axis grid lines
              },
              scaleLabel: {
                display: true,
                labelString: 'No of days',
              },
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
               
                autoSkip: false,
                callback: function(value) {
                  // Break y-axis labels into two lines
                  const maxLength = 25; // Maximum characters per line
                  if (value.length > maxLength) {
                    const words = value.split(' ');
                    let line = '';
                    let lines = [];
                    words.forEach(word => {
                      if ((line + word).length > maxLength) {
                        lines.push(line);
                        line = word + ' ';
                      } else {
                        line += word + ' ';
                      }
                    });
                    lines.push(line);
                    return lines;
                  }
                  return value;
                }
                
              },
              gridLines: {
                display: false, // Hide x-axis grid lines
              },
              scaleLabel: {
                display: true,
                // labelString: 'Number of Facilities',
              },
              // gridLines: {
              //   display: false, // Hide x-axis grid lines
              // }
            }]
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                //return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
                return 'Number of Facilities' + ': ' + tooltipItem.yLabel;
              }
            }
          },
          legend: {
            display: false, // Display the legend
            //position: 'bottom', // Set the legend position to 'bottom'
          },
          plugins: {
            datalabels: {
              color: 'white', // Set the color of the data labels
              display: true,  // Enable data label display
              font: {
                weight: 'bold'  // Make the data labels bold
              }
            },
          },
        }
      });


  
     // this.facilityList=this.tableData
      
    })
  
  }
  horizontalSecondBarChart(params?) {
    this.tableData = [];
    let filter='';
    if(params){
      filter=params
    }
    console.log(this.cseParams);
    this.adminService.getMapListing(filter, sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log(response['data'],'data');
      this.tableData = response.data; 
      //const latestData=response.data?.slice(0, 5);
      const latestData=[
        {
          "name": "ARTIST",
          "value": 59
        },
        {
          "name": "Eva Multispeciality Clinic",
          "value": 689
        },
        {
          "name": "Gupte CSE",
          "value": 124
        },
        {
          "name": "HLFPPT",
          "value": 49
        },
        {
          "name": "KHIPS",
          "value": 328
        },
        {
          "name": "Krishna CSE",
          "value": 115
        },
        {
          "name": "NMOGS",
          "value": 209
        },
        {
          "name": "OMEGA",
          "value": 137
        },
        {
          "name": "Vyas CSE",
          "value": 210
        }
      ]
      
      this.grandTotal = this.tableData.reduce(
        (total, current) => total + parseInt(current.userCount || '0'),
        0
      )
       // Check if response data is empty
      if(!response.data.length){
        this.qiProvidersData = false
      }
   // Sort table and destroy chart instances
      this.sortTable('cse_name','cse');
      if (this.horizontalSecondChartH) this.horizontalSecondChartH.destroy();
 // Set up chart data
      const ctx = this.horizontalSecondChart.nativeElement.getContext('2d');
      const dataLabels =  latestData.map(item => item.name);
      const dataValues =  latestData.map(item => item.value);
  
      const maxDataValue = Math.max(...dataValues);
  
      Chart.plugins.register({
        afterDatasetsDraw: function (chart) {
          if (chart.config.type === 'horizontalBar') { // Only apply this code for line charts
            const ctx = chart.ctx;
            const datasets = chart.config.data.datasets;
  
            datasets.forEach(function (dataset, datasetIndex) {
              const meta = chart.getDatasetMeta(datasetIndex);
              if (!meta.hidden) {
                meta.data.forEach(function (element, index) {
                  const data = dataset.data[index];
                  const x = element._model.x;
                  const y = element._model.y;
                  ctx.fillStyle = 'rgba(255, 255, 255, 255)'; // Change the color as needed
                  ctx.font = '12px Arial'; // Label font style
                  ctx.textAlign = 'center';
  
                  // Adjust the vertical position to display the value at the top of the bar
                  ctx.fillText(data +'', x-10, y );
                });
              }
            });
          }
        },
      });
   // Create bar chart
      this.horizontalSecondChartH = new Chart(ctx, {
        type: 'horizontalBar', // Use 'bar' for vertical bar chart
        data: {
          labels: dataLabels,
          datasets: [{
           // label: 'QI Providers',
            data: dataValues,
            backgroundColor: 'rgb(237,21,86)',
            borderColor: 'rgb(237,21,86)',
            borderWidth: 1,
            barPercentage: 0.4,
            barThickness: 30
          }]
        },
        options: {
          responsive: true, // Make the chart responsive
          maintainAspectRatio: false, // Do not maintain the aspect ratio
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                // callback: function (value) {
                //   // Customize the label to break into two lines
                //   const words = value?.split(' ');
                //   return [ words.slice(0,3).join(' '), words.slice(3).join(' ')];
                // },
                
              },
              gridLines: {
                display: false, // Hide x-axis grid lines
              },
              scaleLabel: {
                display: true,
                labelString: 'No of days',
              },
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                autoSkip: false,
                callback: function(value) {
                  // Break y-axis labels into two lines
                  const maxLength = 25; // Maximum characters per line
                  if (value.length > maxLength) {
                    const words = value.split(' ');
                    let line = '';
                    let lines = [];
                    words.forEach(word => {
                      if ((line + word).length > maxLength) {
                        lines.push(line);
                        line = word + ' ';
                      } else {
                        line += word + ' ';
                      }
                    });
                    lines.push(line);
                    return lines;
                  }
                  return value;
                }
              },
              gridLines: {
                display: false, // Hide x-axis grid lines
              },
              scaleLabel: {
                display: true,
              //  labelString: 'Number of Facilities',
              },
              // gridLines: {
              //   display: false, // Hide x-axis grid lines
              // }
            }]
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                //return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
                return 'Number of Facilities' + ': ' + tooltipItem.yLabel;
              }
            }
          },
          legend: {
            display: false, // Display the legend
            //position: 'bottom', // Set the legend position to 'bottom'
          },
          plugins: {
            datalabels: {
              color: 'white', // Set the color of the data labels
              display: true,  // Enable data label display
              font: {
                weight: 'bold'  // Make the data labels bold
              }
            },
          },
        }
      });


  
     // this.facilityList=this.tableData
      
    })
  
  }
  
}

